import { defaultApi, defaultClient } from '@mint-sdk/api-core';

import {
  PatchSingleRuleDeprecatedSchema,
  PatchSingleRuleSchema,
  PatchSingleRuleSchemaDeprecatedResponse,
  PatchSingleRuleSchemaResponse,
  postUTMBuilderQuerySchema,
  UTMBuilderPayloadSchema,
  UTMBuilderRequestSchema,
} from '../shared/schemas/rules.js';
import {
  TaskItemDeprecatedSchema,
  TaskItemSchema,
} from '../shared/schemas/tasks.js';

export const patchSingleRuleDeprecated = defaultApi.declareEndpoint({
  url: `ga4-service/v2/rules/$ruleId` as const,
  method: 'PATCH',
  responseSchema: PatchSingleRuleSchemaDeprecatedResponse,
  requestSchema: PatchSingleRuleDeprecatedSchema,
});

export const patchSingleRule = defaultClient.mutation({
  url: `ga4-service/v2/rules/$ruleId` as const,
  method: 'PATCH',
  responseSchema: PatchSingleRuleSchemaResponse,
  requestSchema: PatchSingleRuleSchema,
  processResponse(data) {
    return data;
  },
});

export const postUtmBuilderDeprecated = defaultApi.declareEndpoint({
  url: 'ga4-service/v2/rules/utm_builder' as const,
  method: 'POST',
  requestSchema: UTMBuilderPayloadSchema,
  responseSchema: TaskItemDeprecatedSchema,
  querySchema: postUTMBuilderQuerySchema,
  snakeCaseQueryParams: true,
});

export const postUtmBuilder = defaultClient.mutation({
  url: 'ga4-service/v3/rules/utm_builder/' as const,
  method: 'POST',
  requestSchema: UTMBuilderRequestSchema,
  responseSchema: TaskItemSchema,
  querySchema: postUTMBuilderQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});
